module.exports = __webpack_public_path__ + "static/media/icon-post-list-on.d6511676.svg";